<template>
  <div></div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';
import { Content } from '@forchange/storytime';
import { Environment } from '@/store/modules/common/types';
import { namespace } from 'vuex-class';
import initSpecial from '../PracticeCourt/initSpecial';

const userModule = namespace('common');

@Component({})
export default class Index extends Vue {
  @Prop({ type: Object }) content!: Content & {
    desktopId: string;
  };
  @userModule.State('environment') environment!: Environment;

  mounted() {
    if (window.storyteller.topContet?.$kind === 'CloudDesktopTurnOn') {
      this.turnOnDesktop();
      window.next();
    }
  }

  turnOnDesktop() {
    const courseId =
      this.environment && this.environment.kind === 'public-preview'
        ? this.environment.sharedKey
        : '';

    initSpecial.call(this, {
      type: 'desktop',
      options: { desktop: { desktopId: this.content.desktopId }, vika: { shareId: '' } },
      courseId
    });
  }
}
</script>
